<template>
  <!-- <div id="app">
    <el-card class="box-card">
      <div class="box_top">
        <h2>瑞银文件管理系统</h2>
      </div>
      <div class="tabs">
        <el-radio-group v-model="typeOperation" size="mini">
          <el-radio-button label="login">登录</el-radio-button>
          <el-radio-button label="register">注册</el-radio-button>
        </el-radio-group>
      </div>
      <loginElement v-if="typeOperation==='login'"></loginElement>
      <registerElement v-if="typeOperation==='register'"></registerElement>

    </el-card>
  </div> -->

  <!-- 自动登录全屏 loading -->
  <div v-if="autoLogging" class="auto-login-mask">
    <div class="auto-login-box">
      <i class="el-icon-loading"></i>
      <p>正在登录，请稍候...</p>
    </div>
  </div>

  <div v-else class="login-warpper">
    <div class="container">
      <div class="flex">
        <div class="poster">
          <div class="logo">瑞银文件管理系统</div>
          <div class="poster-content">
            <img src="~@/assets/svg/upload.svg" class="p-box" />
          </div>
        </div>
        <div class="form">
          <h2 class="title">登录</h2>
          <div class="user-layout-login">
            <loginElement v-if="typeOperation === 'login'"></loginElement>
            <registerElement v-if="typeOperation === 'register'"></registerElement>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import * as u from '@/utils/util'
import * as c from '@/utils/config'
import { Decrypt } from '@/utils/util'

export default {
  name: "login",
  components: {
    'loginElement': () => import('@/components/auth/loginElement.vue'),
    'registerElement': () => import('@/components/auth/registerElement.vue'),
  },
  data() {
    return {
      //操作类型-登录-注册
      typeOperation: "login",
      // 检测到 URL 带 username 参数时显示全屏 loading
      autoLogging: window.location.href.indexOf('username') !== -1,
    }
  },
  created() {
    if (this.autoLogging) {
      this._doAutoLogin();
    }
  },
  methods: {
    getUrlCode(key) {
      let results = new RegExp('[?&]' + key + '=([^&#]*)').exec(window.location.href);
      return results ? results[1] : '';
    },
    _doAutoLogin() {
      try {
        const username = Decrypt(decodeURIComponent(this.getUrlCode('username')));
        const password = Decrypt(decodeURIComponent(this.getUrlCode('password')));
        // 清理 URL 参数
        window.history.replaceState(null, '', window.location.href.split('?')[0]);
        // 构建登录参数
        const ruleForm = {
          username,
          password,
          code: '6363',
          randomStr: u.uuid(),
          checkKey: new Date().getTime(),
        };
        // 先获取验证码，再登录
        this.$HttpService.get('/sys-login/getCode', { randomStr: ruleForm.randomStr })
          .then(() => {
            return this.$HttpService.post('/sys-login/login', ruleForm);
          })
          .then(res => {
            u.setLoginInfo(res);
            this.$store.commit('SET_LOGIN_STATE', true);
            const redirect = this.$route.query.redirect;
            setTimeout(() => {
              this.$router.push(redirect || { path: '/file/myFileTree' });
            }, 200);
          })
          .catch(() => {
            // 登录失败，退回登录页正常显示
            this.autoLogging = false;
          });
      } catch(e) {
        this.autoLogging = false;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.auto-login-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .auto-login-box {
    text-align: center;
    color: #409EFF;

    i {
      font-size: 48px;
      animation: spin 1s linear infinite;
    }

    p {
      margin-top: 16px;
      font-size: 15px;
      color: #666;
    }
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.login-warpper {
  min-height: 100%;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin-left: -48%;
    background-image: url(~@/assets/svg/login-bg.svg);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    content: "";
  }

  .container {
    position: relative;
    height: 100%;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;

    .flex {
      display: flex;
      height: 100%;

      .poster {
        width: 50%;
        padding: 40vh 0;
        text-align: center;

        .logo {
          width: 50%;
          position: absolute;
          top: 20%;
          font-size: 28px;
          font-weight: 700;
          transition: all 0.5s;
          line-height: normal;
          color: #fff;
  
        }

        .poster-content {
          margin-top: auto;
          margin-bottom: auto;

          .p-box {
            transition: all 0.5s;
            width: 290px;
          }
        }
      }

      .form {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
          font-size: 30px;
          font-weight: bold;
          opacity: 0.9;
          margin-bottom: 20px;
        }

        .user-layout-login {
          width: 400px;

          label {
            font-size: 14px;
          }

          .forge-password {
            font-size: 14px;
          }

          button.login-button {
            padding: 0 15px;
            font-size: 16px;
            height: 40px;
            width: 100% !important;
          }
        }
      }
    }
  }

  // ==================== 移动端适配 ====================
  @media screen and (max-width: 768px) {
    &::before {
      margin-left: 0;
      background-size: cover;
      background-position: center;
      opacity: 0.3;
    }

    .container {
      // padding: 0 20px;

      .flex {
        flex-direction: column;
        justify-content: center;

        .poster {
          width: 100%;
          padding: 0;
          text-align: center;
          margin-bottom: 30px;

          .logo {
            position: relative;
            top: auto;
            font-size: 24px;
            color: #333;
            margin-bottom: 20px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          .poster-content {
            display: none; // 移动端隐藏装饰图片
          }
        }

        .form {
          width: 100%;
          padding: 0;

          .title {
            font-size: 24px;
            margin-bottom: 24px;
            color: #333;
          }

          .user-layout-login {
            width: 100%;
            max-width: 340px;
            padding: 30px 20px;
            background: rgba(255, 255, 255, 0.95);
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

            label {
              font-size: 14px;
            }

            .forge-password {
              font-size: 13px;
            }

            button.login-button {
              padding: 0 15px;
              font-size: 15px;
              height: 42px;
              width: 100% !important;
            }
          }
        }
      }
    }
  }

  // 小屏幕手机适配（宽度小于 480px）
  @media screen and (max-width: 480px) {
    .container {
      // padding: 0 16px;

      .flex {
        .poster {
          margin-bottom: 20px;

          .logo {
            font-size: 20px;
            margin-bottom: 16px;
          }
        }

        .form {
          .title {
            font-size: 20px;
            margin-bottom: 20px;
          }

          .user-layout-login {
            padding: 24px 16px;
            border-radius: 10px;

            label {
              font-size: 13px;
            }

            .forge-password {
              font-size: 12px;
            }

            button.login-button {
              font-size: 14px;
              height: 40px;
            }
          }
        }
      }
    }
  }

  // 横屏模式适配
  @media screen and (max-width: 768px) and (orientation: landscape) {
    .container {
      .flex {
        flex-direction: row;
        align-items: center;

        .poster {
          width: 40%;
          margin-bottom: 0;
          padding-right: 20px;

          .logo {
            font-size: 20px;
            margin-bottom: 12px;
          }

          .poster-content {
            display: block;

            .p-box {
              width: 150px;
            }
          }
        }

        .form {
          width: 60%;

          .title {
            font-size: 22px;
            margin-bottom: 16px;
          }

          .user-layout-login {
            padding: 20px 16px;
          }
        }
      }
    }
  }

  // 平板竖屏适配（768px - 1024px）
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .container {
      max-width: 900px;
      padding: 0 40px;

      .flex {
        .poster {
          .logo {
            font-size: 26px;
          }

          .poster-content {
            .p-box {
              width: 240px;
            }
          }
        }

        .form {
          .title {
            font-size: 28px;
          }

          .user-layout-login {
            width: 380px;
          }
        }
      }
    }
  }
}
</style>
<!-- 
<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
   background-size: 100%;
   &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin-left: -48%;
    background-image: url(~@/assets/login-bg.svg);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    content: "";
  }
}

.box_top {
  text-align: center;
  padding: 30px;
}

.box-card {
  width: 500px;
  height: 450px;
  padding: 20px;
  margin:  auto;
  // margin-top: 15vh;
  // display: flex; 
  border-radius: 30px;

  .tabs{
    text-align: center;
    margin-bottom: 20px;
  }
  .three_login {
    border-top: 1px solid #dddddd;
    margin-top: 10px;
    padding-top: 10px;
    display: flex;
    width: 100%;

    .group {
      margin: 0 auto;

      span {
        font-size: 12px;
      }

      .el-avatar {
        background: white;
      }
    }

    .group:hover {
      span {
        color: #a73e11;
        cursor: pointer;
      }
    }

  }
}

</style> -->
